import React, { useEffect, useState } from "react";
import { Form, Input, Select, DatePicker } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect, useSelector } from "react-redux";
import { 
	getLeaveDetails, 
	doLeaveCreate, 
} from "../../../../redux/leave/leaveState";
import CrudButtons from "components/button/crudbuttons";
import { DATE_FORMAT, MODULE_LEAVE } from "variables/constants";
import { requiredField } from "utils/crudSagaHelper";
import SwitchField from "components/fields/SwitchField";
import TextArea from "antd/es/input/TextArea";

const LeaveForm = ({
	getRecord, 
	doCreate, 
	doUpdate, 
	recordData, 
	requesting, 
	success, 
	onCancel,
	submitLabel,
	...props
}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = Form.useForm();
	const authUser = useSelector((state) => state.auth.user);
	const { RangePicker } = DatePicker;
	const [formData, setFormData] = useState({
			lve_user_id: null,
			lve_date_range: [],
		});
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
    
  	const onSubmit = (formData) => {	
		if (!recordData?.lve_id) {
			formData.lve_status_id = 70; 
		}

    	try {  
			if (formData.lve_date_range?.length === 2) {
				formData.lve_date_from = formData.lve_date_range[0].format(`${DATE_FORMAT}`);
				formData.lve_date_to = formData.lve_date_range[1].format(`${DATE_FORMAT}`);
			}
			delete formData.lve_date_range;

			if (!formData.lve_user_id) {
				formData.lve_user_id = authUser?.id;
			}
			recordData.lve_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
		
    	<Form form={form}
			className={mode !== "view" ? "form" : ""}
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="lve_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>

			<FormItem
				name="lve_status_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>

			<div className="grid grid-cols-3 gap-y-2 gap-x-4">         		            	            
				{authUser?.user_level === 1 && mode !== "view" && (
					<FormItem
						className="font-medium mb-2"
						label="Employee"
						required
					>
						<FormItem
							name="lve_user_id"
							noStyle
							rules={[requiredField]}
							initialValue={formData?.lve_user_id ?? recordData?.lve_user_id ?? null}
						>
							<Select
								showSearch
								allowClear
								className="input-field"
								placeholder="Select Employee"
								onChange={(value) =>
									setFormData((prev) => ({ ...prev, lve_user_id: value }))
								}
								value={formData?.lve_user_id ?? recordData?.lve_user_id ?? undefined}
								options={recordData?.employeeList}
								optionFilterProp="label"
							/>
						</FormItem>
					</FormItem>
				)}  
				
				<FormItem className="font-medium mb-2"
					name="lve_type_id" 
					label="Type"
					rules={[requiredField]}
				>
					<Select id="lve_type_id"
						allowClear={true}
						showSearch
						className="input-field"
						options={recordData?.leaveTypeList}
					/>
				</FormItem>
				
				<FormItem
					className="font-medium mb-2"
					name="lve_date_range" 
					label="Date"
					rules={[requiredField]}
				>
					<RangePicker
						className="input-field w-full"
						format={DATE_FORMAT}
					/>
				</FormItem>

				<FormItem className="font-medium mb-2"
					label="Is Unpaid"
					name="lve_is_unpaid"
					
				>
					<SwitchField
						id="lve_is_unpaid"
						mode="edit"
						type="text"
						labelYes="Yes"
						labelNo="No"
					/>
				</FormItem>

				<FormItem
					className="font-medium mb-2 col-span-3"
					name="lve_reason"
					label="Reason"
					rules={[requiredField]}
				>
					<TextArea
						id="lve_reason"
						className="input-field"
						maxLength={255}
						placeholder="State a reason..."
					/>
				</FormItem>
			</div>
			<div>
				{(mode === "edit") && (
					<CrudButtons 
						mode={mode} 
						recordId={recordData?.lve_id ?? 0} 
						isModal={true}
						modalId={recordData?.lve_id > 0 ? 'edit_leave' : 'add_leave'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel="Submit"
						moduleId={MODULE_LEAVE}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.leave.leaveDetails?.data,
  	requesting: state.leave.leaveDetails?.requesting,
  	success: state.leave.leaveDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getLeaveDetails(id)),
  	doCreate: (data) => dispatch(doLeaveCreate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveForm);
